import {createStore, applyMiddleware, compose, StoreEnhancer, UnknownAction} from 'redux';
import { thunk } from 'redux-thunk';
import {history} from './history';
import appReducer from './modules';
import socketIoReduxMiddleware from './middleware/socketIoReduxMiddleware';
import type { RootState } from './modules';

const rootReducer = (state: RootState | undefined, action: UnknownAction) => {
  // if we log out, we clear state in redux
  if (action.type === 'user/LOGGED_OUT') {
    state = undefined;
  }
  return appReducer(state, action);
};

export {history};

const enhancers: StoreEnhancer[] = [];
const middleware = [
  thunk,
  socketIoReduxMiddleware()
];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const middlewareEnhancer = applyMiddleware(...middleware);
const composedEnhancers: StoreEnhancer = enhancers.length
  ? compose(middlewareEnhancer, ...enhancers) as StoreEnhancer
  : middlewareEnhancer;

const store = createStore(rootReducer, composedEnhancers);

export default store;
